import { connect } from 'react-redux';
import ScribeReportModal from './ScribeReportModal';
import { firebaseLoginSuccess } from '../../actions';

const mapStateToProps = ({
  scribeConversation: { id: conversationId, status },
  firebase: { user: firebaseUser },
}) => ({
  conversationId,
  firebaseUser,
  status,
});

export default connect(
  mapStateToProps,
  { firebaseLoginSuccess }
)(ScribeReportModal);
